import { defineRule } from '../define-rule'
import { assertNotNullish, assertPrimitives } from '@/libs/utils/assertion.util'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type CharMinRuleConstructorParams = BaseRuleConstructorParams<{ min: number }>

export const charMin = defineRule(
  'char_min',
  ({ config, errorMessage }: CharMinRuleConstructorParams) => {
    const { min } = config
    const error = errorMessage ?? false
    assertNotNullish(min)
    return (value) => {
      try {
        assertPrimitives(value, 'string', 'number')
        return String(value).length >= min || error
      } catch (e) {
        console.error('Error while executing dateIsValid', e)
        return error
      }
    }
  }
)
